import { normalizeId } from './ids';
export const getOrganizationId = (organization) => normalizeId(organization);

export const getOrganizationDashboardPath = (organization) => {
  const organizationId = getOrganizationId(organization);
  return organizationId ? `/org/${organizationId}/dashboard` : '';
};

const getTournamentAdminId = normalizeId;

export const getTournamentAdminDashboardPath = (organization, tournamentAdmin) => {
  const organizationId = getOrganizationId(organization);
  const tournamentAdminId = getTournamentAdminId(tournamentAdmin);

  if (!organizationId || !tournamentAdminId) return '';

  return `/org/${organizationId}/tournament-admin/${tournamentAdminId}/tournaments`;
};

export const getPlayerManagerDashboardPath = (organization, playerManager) => {
  const organizationId = getOrganizationId(organization);
  const playerManagerId = getTournamentAdminId(playerManager);

  if (!organizationId || !playerManagerId) return '';

  return `/org/${organizationId}/player-manager/${playerManagerId}/tournaments`;
};

export const getMatchManagerDashboardPath = (organization, matchManager) => {
  const organizationId = getOrganizationId(organization);
  const matchManagerId = getTournamentAdminId(matchManager);

  if (!organizationId || !matchManagerId) return '';

  return `/org/${organizationId}/match-manager/${matchManagerId}/tournaments`;
};

const getManagerId = normalizeId;

export const getAuctionManagerPath = (organization, auctionManager, tournament) => {
  const organizationId = getOrganizationId(organization);
  const auctionManagerId = getManagerId(auctionManager);
  const tournamentId = getManagerId(tournament);

  if (!organizationId || !auctionManagerId || !tournamentId) return '';

  return `/org/${organizationId}/auction-manager/${auctionManagerId}/tournaments/${tournamentId}`;
};
